import { ReactNode, HTMLAttributes } from "react";

type TabsContainerProps = HTMLAttributes<HTMLUListElement> & {
	children: ReactNode;
};

export function TabsContainer({ children, ...rest }: TabsContainerProps) {
	return (
		<ul
			className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap mb-3 mt-2 px-4"
			{...rest}
		>
			{children}
		</ul>
	);
}
